import { triggerHapticFeedback } from "../haptics";
import { playRankUp } from "../sound_manager";

// FLIP animation for the ranking rows: snapshot each row's position before LiveView
// patches the list, then translate every moved row from its old slot to its new one.
// Entries are keyed by `data-user-id` (podium cards included, for the viewer
// celebration); the viewer's entry is `data-viewer="true"`.
const LeaderboardRowsHook = {
  mounted() {
    this.reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    this.previous = this.snapshot();
  },

  beforeUpdate() {
    this.previous = this.snapshot();
  },

  updated() {
    const next = this.snapshot();

    if (!this.reduceMotion) {
      this.animateMoves(next);
    }

    this.celebrateViewer(next);
    this.previous = next;
  },

  rows() {
    return [...this.el.querySelectorAll("[data-user-id]")];
  },

  snapshot() {
    const map = new Map();

    this.rows().forEach((row) => {
      map.set(row.dataset.userId, {
        top: row.getBoundingClientRect().top,
        ranking: parseInt(row.dataset.ranking || "0", 10),
        count: parseInt(row.dataset.count || "0", 10),
        viewer: row.dataset.viewer === "true",
      });
    });

    return map;
  },

  animateMoves(next) {
    this.rows().forEach((row) => {
      // Podium cards carry their own transforms; only the table rows slide.
      if (!row.classList.contains("z-lb-row")) return;

      const before = this.previous.get(row.dataset.userId);
      const after = next.get(row.dataset.userId);

      if (!before) {
        // Newcomers fade in like the prize table rows.
        row.classList.add("lottery-fade-in");
        return;
      }

      const delta = before.top - after.top;

      if (Math.abs(delta) > 1) {
        row.classList.add("is-moving");
        row.style.transition = "none";
        row.style.transform = `translateY(${delta}px)`;

        requestAnimationFrame(() => {
          row.style.transition = "";
          row.style.transform = "";

          const done = () => {
            row.classList.remove("is-moving");
            row.removeEventListener("transitionend", done);
          };

          row.addEventListener("transitionend", done);
        });
      }

      if (after.count > before.count) {
        row.classList.remove("is-bumped");
        // Restart the highlight even if it is still running.
        void row.offsetWidth;
        row.classList.add("is-bumped");
      }
    });
  },

  celebrateViewer(next) {
    const viewerBefore = [...this.previous.values()].find((r) => r.viewer);
    const viewerAfter = [...next.values()].find((r) => r.viewer);

    if (!viewerBefore || !viewerAfter) return;

    if (viewerAfter.ranking < viewerBefore.ranking) {
      playRankUp();
      triggerHapticFeedback([30, 20, 60]);
    } else if (viewerAfter.count > viewerBefore.count) {
      triggerHapticFeedback(20);
    }
  },
};

export default LeaderboardRowsHook;
